export const getStage = state => state.bootstrapReducer.stage
